'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');
var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');
var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require('babel-runtime/helpers/createClass');
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = require('babel-runtime/helpers/inherits');
var _inherits3 = _interopRequireDefault(_inherits2);
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
require('./icons.scss');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/* eslint-disable */
var RugbyLeague = function (_PureComponent) {
  (0, _inherits3.default)(RugbyLeague, _PureComponent);
  function RugbyLeague() {
    (0, _classCallCheck3.default)(this, RugbyLeague);
    return (0, _possibleConstructorReturn3.default)(this, (RugbyLeague.__proto__ || (0, _getPrototypeOf2.default)(RugbyLeague)).apply(this, arguments));
  }
  (0, _createClass3.default)(RugbyLeague, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        className = _props.className,
        otherProps = (0, _objectWithoutProperties3.default)(_props, ['className']);
      return _react2.default.createElement('svg', (0, _extends3.default)({
        viewBox: '0 0 32 32',
        style: {
          width: '1em',
          height: '1em'
        },
        preserveAspectRatio: 'xMidYMid meet'
      }, otherProps, {
        className: (0, _classnames2.default)('sb-icon-svg', className),
        xmlns: 'http://www.w3.org/2000/svg'
      }), _react2.default.createElement('path', {
        d: 'M25.9.9C21.6-1.8 12 1.7 6.7 9.8s-4.8 18.4-.6 21.3c4.3 2.7 13.9-.8 19.2-9s4.8-18.3.6-21.2zM24 21.3c-4 6-10.3 9.2-14.4 9.2h-.1c-.7 0-1.3-.1-1.9-.3l4.8-7.3-1.3-.9-4.8 7.3C3.7 26.4 3.2 18 8 10.7c3.9-6 10.2-9.1 14.4-9.1h.1c.7 0 1.3.1 1.9.3l-4.8 7.2 1.3.9 4.8-7.2C28.2 5.6 28.8 14 24 21.3zm-2.6-6.9l2.2 1.4-4.8 7.4-10.5-6.9 1.9-2.9 8.3 5.4 2.9-4.4z'
      }));
    }
  }]);
  return RugbyLeague;
}(_react.PureComponent);
RugbyLeague.propTypes = {
  className: _propTypes.PropTypes.string
};
exports.default = RugbyLeague;